const LOCAL_DEV_PORTS: Record<string, number> = {
  '/institutional-market/': 3001,
  '/institutional-market-admin/': 3002,
  '/consumer-retail/': 3003,
  '/consumer-retail-admin/': 3010,
  '/scenic/': 3005,
  '/market-maker/': 3006,
  '/supervise/': 3007,
  '/bank/': 3008,
  '/total-admin/': 3009,
};

function normalizeAppBasePath(path: string): string {
  if (!path) return '/';
  const withLeadingSlash = path.startsWith('/') ? path : `/${path}`;
  return withLeadingSlash.endsWith('/') ? withLeadingSlash : `${withLeadingSlash}/`;
}

function normalizeRoutePath(path: string): string {
  return String(path || '').replace(/^\/+/, '');
}

function isLocalDevHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function getAppUrl(path: string): string {
  const normalizedPath = normalizeAppBasePath(path);

  if (typeof window === 'undefined') {
    return normalizedPath;
  }

  const devPort = LOCAL_DEV_PORTS[normalizedPath];
  if (devPort && isLocalDevHost(window.location.hostname)) {
    return `${window.location.protocol}//${window.location.hostname}:${devPort}${normalizedPath}`;
  }

  return normalizedPath;
}

export function getAppRouteUrl(appBasePath: string, routePath = ''): string {
  const normalizedBasePath = normalizeAppBasePath(appBasePath);
  const normalizedRoutePath = normalizeRoutePath(routePath);

  if (typeof window !== 'undefined') {
    const devPort = LOCAL_DEV_PORTS[normalizedBasePath];
    if (devPort && isLocalDevHost(window.location.hostname)) {
      const appOrigin = `${window.location.protocol}//${window.location.hostname}:${devPort}`;
      return normalizedRoutePath ? `${appOrigin}/${normalizedRoutePath}` : `${appOrigin}/`;
    }
  }

  const appBaseUrl = getAppUrl(normalizedBasePath);
  return normalizedRoutePath ? `${appBaseUrl}${normalizedRoutePath}` : appBaseUrl;
}

export function getTotalAdminAccountManagementUrl(): string {
  return getAppRouteUrl('/total-admin/', 'account-management');
}

export function openTotalAdminAccountManagement(): void {
  if (typeof window === 'undefined') return;
  window.location.assign(getTotalAdminAccountManagementUrl());
}
